<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div style="width: 100%; height: 58%">
        <!-- <dv-charts class="ring-charts" :option="option" /> -->
        <div style="line-height:1rem;text-align: center;padding:15px 20px;height: 20vh;">
          <div :style="{ 'color': dColor, 'font-size': '0.75rem', 'font-weight': 'bold' }">
            {{
              data['title'] }}
          </div>
          <div style="font-size:0.7rem;font-weight:600;color:white;">{{ data['value'] }} <span
              v-if="data['value'] != '无生产计划'">%</span>
          </div>
        </div>
        <div class="issueCls" style="background-color: #143F6C;padding:1%;height:30vh;">
          <div class="title" style="height:15%">{{ data['title'] }} 主要问题</div>
          <div v-if="dColor == 'red'"
            style="padding-left:8%;margin-top:0.1rem;height:80%;overflow:hidden; overflow-y: scroll;">
            <ul style="line-height:0.52rem;font-size:0.226rem;list-style-type: decimal;">
              <li v-for="(team, i) in issues" :key="i">
                <template>
                  <span v-if="data['title'] == 'OEE' || data['title'] == 'FTT'">
                    {{ (i + 1) }}. {{ team.device }}&nbsp;&nbsp;
                  </span>
                  <span v-html="team.faiCause"></span>
                  <template v-if="data['title'] == 'OEE'">&nbsp;{{ team.duration }} 分钟</template>
                  <template v-if="data['title'] == 'FTT'">&nbsp;{{ team.quantity }} 个</template>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 42%" :id="data['id'] + 'bar'"></div>
    </dv-border-box-7>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "oee-kpi-productline-total",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
    updateTime: {
      type: Number,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      data: this.bean,
      current: {},
      option: {},
      refreshTime: null,
      dColor: '#00E690',
      issues: [],
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.data = val;
        var _this = this;
        this.$nextTick(() => {
          _this.formatData();
        });

      },
      deep: true,
      immediate: true
    },
    updateTime: function (val, oldVal) {
      this.refreshTime = format(val, "HH:mm:ss");
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    decimal2(num) {
      // 先将数字乘以 10，使用 toFixed 方法将结果保留 0 位小数，再除以 10
      if (num == 0 || num == 100) {
        return num;
      }
      let result = parseFloat((num * 10).toFixed(0)) / 10;
      return result;
    },
    formatData() {
      var data = this.data;
      var value = data["value"] || 0;
      var weekList = data["weekList"] || [];
      var minTitle = data["minTitle"];
      var kpi = data["kpi"] || 95;

      var color = value >= kpi ? "#00E690" : "red";

      if (data["id"].indexOf('scrap') > -1) {
        color = value <= kpi ? "#00E690" : "red";
      }

      if ('无生产计划' == value) {
        color = '#00E690';
      }

      this.dColor = color;
      var issues = data['issueList'];
      var scarpStr = [];
      for (var i = 0; i < issues.length; i++) {
        if (data['id'] == 'scrap') {
          var splitStr = issues[i]['faiCause'].split('\n');
          for (var s = 0; s < splitStr.length; s++) {
            if (splitStr[s] && splitStr[s].trim().length > 0) {
              scarpStr.push({ 'faiCause': splitStr[s] });
            }
          }
        } else {
          issues[i]['faiCause'] = issues[i]['faiCause'].replaceAll('\n', '<br/>');
        }
      }

      if (data['id'] == 'scrap') {
        if (scarpStr.length > 3) {
          this.issues = scarpStr.slice(0, 3);
        } else {
          this.issues = scarpStr;
        }
      } else {
        this.issues = issues;
      }

      this.option = {
        series: [
          {
            center: ["50%", "50%"],
            radius: "70%",
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 18,
            data: [
              {
                name: data["id"],
                value: value,
                gradient: [color],
              },
            ],
            dataItemStyle: {
              fill: "#FFF",
              fontSize: 13,
              textAlign: "right",
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            backgroundArc: {
              show: true,
              style: {
                fill: "#0B2140",
                stroke: "#0B2140",
              },
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "{value}%",
              style: {
                fill: "#fff",
                fontSize: 65,
                fontFamily: "electronicFont",
              },
            },
          },
        ],
      };

      var barOpt = this.$echarts.init(
        document.getElementById(data["id"] + "bar")
      );

      var maxNum = null;
      var minNum=60;
      var interVal = null;
      const xAxis = [];
      const lineData = [];
      const lineKpi = [];

      weekList.forEach((item) => {
        xAxis.push(item.week);
        if (data["id"].indexOf('oee') > -1) {
          lineData.push(this.decimal2(item.oee));
          lineKpi.push(item.oeeKpi);
        } else if (data["id"].indexOf('ftq') > -1) {
          lineData.push(this.decimal2(item.ftq));
          lineKpi.push(item.ftqKpi);
        } else {
          lineData.push(item.scrap ? (item.scrap.toFixed(2)) : 0);
          lineKpi.push(data.kpi ? (data.kpi.toFixed(2)) : data.kpi);
          var scrapMax = Math.max.apply(null, lineData);
          var kpiMax = Math.max.apply(null, lineKpi);
          if (scrapMax > kpiMax) {
            maxNum = (scrapMax * 1.2).toFixed(2);
          } else {
            maxNum = (kpiMax * 1.2).toFixed(2);
          }
          minNum=0;
        }
      });



      var option2 = {
        title: {
          text: minTitle,
          left: "center",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        grid: {
          top: 35,
          bottom: 25,
          x: 40,
          y: 50,
          left: 60,
        },
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 13,
              },
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            name: "%",
            nameGap: 5,
            type: "value",
            min: minNum,
            axisLabel: {
              //  formatter: "{value} %",
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: true, //隐藏
            },
            interval: interVal,
            max: maxNum,
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        label: {
          show: true,
          position: "inside",
          style: {
            fontSize: 10,
          },
          // formatter: (params) => {
          //   return params.value + "%";
          // },
        },
        series: [
          {
            name: "实际",
            type: "bar",
            data: lineData,
            barWidth: 30,
            barGap: "-100%",
            itemStyle: {
              normal: {
                color: function (params) {
                  if (params["value"] == 0) {
                    return "white";
                  } else {
                    if (data["id"].indexOf('scrap') > -1) {
                      return params["value"] <= lineKpi[0] ? "#00E690" : "red";
                    } else {
                      return params["value"] >= lineKpi[0] ? "#00E690" : "red";
                    }
                  }
                },
              },
            },
            color: "red",
            markLine: {
              symbol: ["none", "none"], //去掉箭头
              lineStyle: {
                type: "dashed",
                normal: {
                  type: "solid",
                  color: "#00E690 ", // 这儿设置安全基线颜色
                },
              },
              data: [
                {
                  yAxis: lineKpi[0],
                },
              ],
              label: {
                show: true,
                distance: [-20, 0],
                position: "insideStartBottom",
                color: "#00E690",
              },
            },
          },
        ],
      };

      barOpt.setOption(option2);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style>
.pagebg {
  background-size: 100%;
  background: url("../../../../../assets/img/8dbg.png") center center / cover no-repeat;
}

.cred {
  color: red;
}

.cgreen {
  color: green;
}

.title {
  height: 30px;
  margin-bottom: 0px;
  font-weight: bold;
  text-indent: 20px;
  font-size: 0.45rem;
  text-align: center;
  align-items: center;
}
</style>
<style scoped src='./board.css'></style>




// WEBPACK FOOTER //
// src/pages/oee/weektracking/kpi/component/oee-productline-total.vue